<mat-icon class="siren-popover-close-button" svgIcon="close" [mat-dialog-close]="true"></mat-icon>

<div class="vi-siren-main-container vi-siren-header-title">
  <mat-card-title
    *ngIf="sirenSaveStatusMessage"
    [ngClass]="{
      'siren-status-error': sirenSaveStatusMessage.includes('failed'),
      'siren-status-in-progress': sirenSaveStatusMessage.includes('Please wait')
    }"
    class="siren-status-text siren-text"
    >{{ sirenSaveStatusMessage }}</mat-card-title
  >
  <div><span mat-dialog-title class="siren-title">Siren Enable</span></div>
</div>
<div class="vi-siren-main-container vi-siren-workflow-container pd-left10">
  <mat-card-title class="siren-camera-offline" *ngIf="deviceOffline">{{ cameraOfflineErrorMsg }}</mat-card-title>
  <div class="header-font">Workflows</div>
  <div class="vi-siren-workflow-list">
    <div *ngFor="let workflow of workflows">
      <mat-checkbox
        *ngIf="!isLoading"
        [checked]="workflow.isChecked"
        [color]="'red'"
        [labelPosition]="'after'"
        [disabled]="false"
        (change)="onWorkflowChange($event, workflow)"
        [disableRipple]="true">
        {{ workflow.name }}
      </mat-checkbox>
    </div>
  </div>

  <div class="last-update-detail-container" *ngIf="savedSirenDetails">
    <p class="last-update-time-label">
      <span class="last-update-time">Last Updated At: </span>
      <span class="last-update-detail">{{ savedSirenDetails.updateAt | date : 'MMM d, y, h:mm:ss a' : currentZoneDetails.timezone }}</span>
    </p>
    <p>
      <span class="last-update-time">Last Updated By: </span><span class="last-update-detail">{{ savedSirenDetails.updateBy }}</span>
    </p>
  </div>

  <app-spinner *ngIf="isLoading"></app-spinner>
  <div class="footer-button">
    <button class="clear-btn" slb-secondary-button type="button" (click)="closeDialog()">Cancel</button>
    <button class="apply-btn" slb-button (click)="saveWorkflow()" [disabled]="deviceOffline || disableApply">Save</button>
  </div>
</div>
